module.exports = __webpack_public_path__ + "img/logo.810c9943.svg";